export const getEstimatesSlice = (state) => state.estimates;

export const getEstimates = (state) => {
	const slice = getEstimatesSlice(state);

	let estimates = [];
	if (!Array.isArray(slice)) {
		estimates = Object.values(slice?.byId);
	}

	return estimates;
};

export const getEstimatesPagingOptions = (state) => {
	let pagingOptions = {
		page: getEstimatesSlice(state)?.page,
		pages: getEstimatesSlice(state)?.pages
	};
	return pagingOptions;
};
